const DropdownArrow = ({
  width = "32",
  height = "32",
  fill = "#000",
  viewBox = "0 0 24 24",
  className = "inline vMiddle arrowsvg",
}) => {
  return (
    <svg
      className={className ? className : null}
      width={width}
      height={height}
      viewBox={viewBox}

    >
      <path d="M7 10l5 5 5-5z"  fill={fill} />
    </svg>
  );
};
export default DropdownArrow;
